import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject } from "rxjs";

@Component({
  selector: "app-setting-edit-primary-email",
  templateUrl: "./setting-edit-primary-email.component.html",
  standalone:false,
  styleUrls: ["./setting-edit-primary-email.component.scss"],
})
export class SettingEditPrimaryEmailComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  selectedCity: string = "";
  CityList;
  constructor(private location: Location, private router: Router) {}

  async ngOnInit(): Promise<void> {
    this.CityList = [
      {
        iconClass: "",
        displayValue: "MANAMA",
      },
      {
        iconClass: "",
        displayValue: "MANAMA",
      },
    ];
  }

  settingEditPrimary() {
    this.router.navigateByUrl("/SettingEditPrimary");
  }
  uploadId() {
    this.router.navigateByUrl("/UploadId");
  }
  onCityChange(event) {
    this.selectedCity = event.displayValue;
  }
  back() {
    this.location.back();
  }
}

